var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { extractProjectDictionaryWithLocale } from '@ts-intl/dictionary';
import { Project } from '@ts-intl/shared';
import { readFileSync } from 'fs';
/**
 * run only in server side
 * @param param0
 * @returns
 */
export const withI18nDeps = ({ rootDir, defaultLanguage, ns, disable, entry, dictCache, jsonFileCache, ttl, isEntryDepsEnabled, formatEntry = (entry) => entry, }) => {
    const project = Project.getSingleton(rootDir);
    const { include = [], exclude } = ns !== null && ns !== void 0 ? ns : {};
    return ({ locale }) => __awaiter(void 0, void 0, void 0, function* () {
        const currentLanguage = locale !== null && locale !== void 0 ? locale : defaultLanguage;
        const props = {
            defaultLanguage,
            currentLanguage,
            dictionary: {},
        };
        if (disable)
            return props;
        if (!isEntryDepsEnabled) {
            // development
            props.dictionary = extractProjectDictionaryWithLocale(project, currentLanguage, {
                include,
                exclude,
            });
        }
        else {
            // production
            props.dictionary = cacheDict(JSON.stringify({
                include,
                exclude,
                entry,
                locale: currentLanguage,
            }), () => extractProjectDictionaryWithLocale(project, currentLanguage, {
                include,
                exclude,
                entry: entry ? formatEntry(entry) : undefined,
                reader: (jsonPath) => parseJsonFileWithCache(jsonPath, jsonFileCache, ttl),
            }), dictCache, ttl);
        }
        return props;
    });
};
const TTL_IN_SECOND = 60 * 60 * 24; // day
const cacheDict = (cacheKey, getter, dictCache, ttl = TTL_IN_SECOND) => {
    var _a;
    if (!dictCache)
        return getter();
    const dict = (_a = dictCache.get(cacheKey)) !== null && _a !== void 0 ? _a : getter();
    if (!dictCache.get(cacheKey)) {
        dictCache.set(cacheKey, dict, ttl);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dict;
};
const parseJsonFileWithCache = (jsonPath, jsonFileCache, ttl = TTL_IN_SECOND) => {
    const getter = () => JSON.parse(readFileSync(jsonPath, { encoding: 'utf-8' }));
    if (!jsonFileCache)
        return getter();
    if (!jsonFileCache.get(jsonPath)) {
        jsonFileCache.set(jsonPath, JSON.parse(readFileSync(jsonPath, { encoding: 'utf-8' })), ttl);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return jsonFileCache.get(jsonPath);
};
